export const classOfDegree = () => {
  const classofdegree = [
    "First Class",
    "Second Class Upper",
    "Second Class Lower",
    "Third Class",
  ];

  return classofdegree;
};
export const degrees = () => {
  const degree = ["B.Sc", "B.Tech", "B.A", "HND", "OND", "B.Eng", "Msc", "PHD"];

  return degree;
};
export const getFullDate = (datestring: string) => {
  const date = new Date(datestring);
  const dateFormat =
    date.toLocaleDateString("en-US", { day: "numeric" }) +
    " " +
    date.toLocaleDateString("en-US", { month: "short" }) +
    "," +
    date.toLocaleDateString("en-US", { year: "numeric" });
  return dateFormat;
};

export const getFullTime = (datestring: string) => {
  const time = new Date(datestring);
  const getAMPM = (time: Date) => {
    if (time.getUTCHours() > 11) {
      return "PM";
    } else {
      return "AM";
    }
  };
  const timeFormat =
    time.getUTCHours() + ":" + time.getUTCMinutes() + " " + getAMPM(time);
  return timeFormat;
};
